const DASHBOARD = 'dashboard';

const USER = 'users';
const USER_SHOW = 'users_show';
const USER_NEW = 'users_new';
const USER_EDIT = 'users_edit';
const USER_CHANGE_PWD = 'users_change_pwd';

const EDITOR = 'editors';
const EDITOR_SHOW = 'editors_show';
const EDITOR_NEW = 'editors_new';
const EDITOR_EDIT = 'editors_edit';

const EDITOR_GROUP = 'editors_group';
const EDITOR_GROUP_NEW = 'editors_group_new';
const EDITOR_GROUP_EDIT = 'editors_group_edit';
const EDITOR_GROUP_SHOW = 'editors_group_show';


const BOOK = 'books';
const BOOK_SHOW = 'books_show';
const BOOK_NEW = 'books_new';
const BOOK_EDIT = 'books_edit';
const BOOK_IMPORT = 'book_import';

const TEACHER = 'teachers';
const TEACHER_SHOW = 'teachers_show';
const TEACHER_NEW = 'teachers_new';
const TEACHER_EDIT = 'teachers_edit';

const PROPAGANDIST = 'propagandists';
const PROPAGANDIST_SHOW = 'propagandists_show';
const PROPAGANDIST_NEW = 'propagandists_new';
const PROPAGANDIST_EDIT = 'propagandists_edit';

const SCHOOL = 'schools';
const SCHOOL_SHOW = 'schools_show';
const SCHOOL_NEW = 'schools_new';
const SCHOOL_EDIT = 'schools_edit';
const SCHOOL_GRID = 'schools_grid';

const SCHOOL_TYPE = 'schools_type';
const SCHOOL_TYPE_SHOW = 'schools_type_show';
const SCHOOL_TYPE_NEW = 'schools_type_new';
const SCHOOL_TYPE_EDIT = 'schools_type_edit';

const ZONE = 'zones';
const ZONE_SHOW = 'zones_show';
const ZONE_NEW = 'zones_new';
const ZONE_EDIT = 'zones_edit';

const SUBJECT = 'subjects';
const SUBJECT_SHOW = 'subjects_show';
const SUBJECT_NEW = 'subjects_new';
const SUBJECT_EDIT = 'subjects_edit';

const WAREHOUSE = 'warehouses';
const WAREHOUSE_SHOW = 'warehouses_show';
const WAREHOUSE_NEW = 'warehouses_new';
const WAREHOUSE_EDIT = 'warehouses_edit';

const WAREHOUSE_UNLOAD = 'warehouses_unload';
const WAREHOUSE_UNLOAD_SHOW = 'warehouses_unload_show';
const WAREHOUSE_UNLOAD_NEW = 'warehouses_unload_new';

const WAREHOUSE_LOAD = 'warehouses_load';
const WAREHOUSE_LOAD_SHOW = 'warehouses_load_show';
const WAREHOUSE_LOAD_NEW = 'warehouses_load_new';
const WAREHOUSE_LOAD_IMPORT = 'warehouse_load_import';

const WAREHOUSE_TRANSFER = 'warehouses_transfer';
const WAREHOUSE_TRANSFER_SHOW = 'warehouses_transfer_show';
const WAREHOUSE_TRANSFER_NEW = 'warehouses_transfer_new';

const CAMPAIGN_TEACHER = 'campaign_teacher';
const CAMPAIGN_SUBJECT = 'campaign_subject';
const CAMPAIGN_SCHOOL = 'campaign_school';
const CAMPAIGN_SCHOOL_RESULT = 'campaign_school_result';

const CAMPAIGN_REPORT = 'campaign_report';
const CAMPAIGN_REPORT_SAMPLE = 'campaign_report_sample';
const CAMPAIGN_REPORT_BOOKED = 'campaign_report_booked';
const CAMPAIGN_REPORT_BOOKED_ORDER = 'campaign_report_booked_order';
const CAMPAIGN_REPORT_ORDERED = 'campaign_report_ordered';
const CAMPAIGN_REPORT_ALL = 'campaign_report_all';
const CAMPAIGN_REPORT_ESTIMATES = 'campaign_report_estimates';
const CAMPAIGN_REPORT_ESTIMATE_DETAIL = 'campaign_report_estimate_detail';

const COMMUNICATION = 'communications';
const COMMUNICATION_NEW = 'communications_new';
const COMMUNICATION_EDIT = 'communications_edit';

const ADOPTION = 'adoptions';
const ADOPTION_SHOW = 'adoptions_show';
const ADOPTION_IMPORT = 'adoptions_import';
const ADOPTION_REPORT = 'adoptions_report';
const ADOPTION_REPORT_PROPAGANDIST_SCHOOL = 'adoptions_report_propagandist_school';
const ADOPTION_REPORT_SCHOOL = 'adoptions_report_school';
const ADOPTION_REPORT_EDITOR = 'adoptions_report_editor';
const ADOPTION_REPORT_EDITOR_PROPAGANDIST = 'adoptions_report_editor_propagandist';
const ADOPTION_REPORT_EDITOR_SCHOOL = 'adoptions_report_editor_school';
const ADOPTION_REPORT_PROPAGANDIST = 'adoptions_report_propagandist';
const ADOPTION_REPORT_PROPAGANDIST_EDITOR = 'adoptions_report_propagandist_editor';
const ADOPTION_REPORT_PROPAGANDIST_BOOK = 'adoptions_report_propagandist_book';

const ADOPTION_REPORT_BOOK_PROPAGANDIST = 'adoptions_report_book_propagandist';
const ADOPTION_REPORT_BOOK_SCHOOL = 'adoptions_report_book_school';
const ADOPTION_REPORT_TOTAL_SCHOOL = 'adoptions_report_school_total';

const PRINT_BULLETTINS = 'print_bullettins';

const ROLE = 'role';
const ROLE_SHOW = 'role_show';

const APP_SETTINGS = 'settings_app';

const ANOMALY_DASHBOARD = 'anomaly_dashboard';
const ANOMALY_BOOKED_ZERO = 'anomaly_booked_zero';
const ANOMALY_ASSIGNED_LOOP = 'anomaly_assigned_loop';
const ANOMALY_DUPLICATE = 'anomaly_duplicate';
const ANOMALY_BOOKED_AVAILABLE = 'anomaly_booked_available';
const ANOMALY_SCHOOL_MISMATCH = 'anomaly_school_mismatch';
const ANOMALY_ORDERS_MISSING = 'anomaly_orders_missing';
const ANOMALY_ORPHAN_TEACHERS = 'anomaly_orphan_teachers';
const ANOMALY_VQTY_MISMATCH = 'anomaly_vqty_mismatch';

const SUPPORT = 'support';
const SUPPORT_LIST = 'support_list';
const SUPPORT_SHOW = 'support_show';


// const INCOMING_BOOKS = 'incoming_books';
const BOXES = 'boxes';

const routeNames = {
    DASHBOARD,

    USER,
    USER_SHOW,
    USER_NEW,
    USER_EDIT,
    USER_CHANGE_PWD,

    EDITOR,
    EDITOR_SHOW,
    EDITOR_NEW,
    EDITOR_EDIT,

    EDITOR_GROUP,
    EDITOR_GROUP_NEW,
    EDITOR_GROUP_EDIT,
    EDITOR_GROUP_SHOW,

    BOOK,
    BOOK_SHOW,
    BOOK_NEW,
    BOOK_EDIT,
    BOOK_IMPORT,

    TEACHER,
    TEACHER_SHOW,
    TEACHER_NEW,
    TEACHER_EDIT,

    PROPAGANDIST,
    PROPAGANDIST_SHOW,
    PROPAGANDIST_NEW,
    PROPAGANDIST_EDIT,

    SCHOOL,
    SCHOOL_SHOW,
    SCHOOL_NEW,
    SCHOOL_EDIT,
    SCHOOL_GRID,

    SCHOOL_TYPE,
    SCHOOL_TYPE_SHOW,
    SCHOOL_TYPE_NEW,
    SCHOOL_TYPE_EDIT,

    ZONE,
    ZONE_SHOW,
    ZONE_NEW,
    ZONE_EDIT,

    SUBJECT,
    SUBJECT_SHOW,
    SUBJECT_NEW,
    SUBJECT_EDIT,

    WAREHOUSE,
    WAREHOUSE_SHOW,
    WAREHOUSE_NEW,
    WAREHOUSE_EDIT,
    WAREHOUSE_UNLOAD,
    WAREHOUSE_UNLOAD_SHOW,
    WAREHOUSE_UNLOAD_NEW,
    WAREHOUSE_LOAD,
    WAREHOUSE_LOAD_SHOW,
    WAREHOUSE_LOAD_NEW,
    WAREHOUSE_LOAD_IMPORT,
    WAREHOUSE_TRANSFER,
    WAREHOUSE_TRANSFER_SHOW,
    WAREHOUSE_TRANSFER_NEW,

    CAMPAIGN_TEACHER,
    CAMPAIGN_SUBJECT,
    CAMPAIGN_SCHOOL,
    CAMPAIGN_SCHOOL_RESULT,
    CAMPAIGN_REPORT,
    CAMPAIGN_REPORT_SAMPLE,
    CAMPAIGN_REPORT_BOOKED,
    CAMPAIGN_REPORT_BOOKED_ORDER,
    CAMPAIGN_REPORT_ORDERED,
    CAMPAIGN_REPORT_ALL,
    CAMPAIGN_REPORT_ESTIMATES,
    CAMPAIGN_REPORT_ESTIMATE_DETAIL,

    COMMUNICATION,
    COMMUNICATION_NEW,
    COMMUNICATION_EDIT,

    ADOPTION,
    ADOPTION_IMPORT,
    ADOPTION_SHOW,
    ADOPTION_REPORT,

    ADOPTION_REPORT_EDITOR,
    ADOPTION_REPORT_EDITOR_PROPAGANDIST,
    ADOPTION_REPORT_EDITOR_SCHOOL,
    ADOPTION_REPORT_BOOK_PROPAGANDIST,
    ADOPTION_REPORT_BOOK_SCHOOL,
    ADOPTION_REPORT_PROPAGANDIST,
    ADOPTION_REPORT_PROPAGANDIST_EDITOR,
    ADOPTION_REPORT_PROPAGANDIST_SCHOOL,
    ADOPTION_REPORT_SCHOOL,
    ADOPTION_REPORT_PROPAGANDIST_BOOK,
    ADOPTION_REPORT_TOTAL_SCHOOL,

    PRINT_BULLETTINS,

    // INCOMING_BOOKS,
    BOXES,
    ROLE,
    ROLE_SHOW,

    APP_SETTINGS,

    ANOMALY_DASHBOARD,
    ANOMALY_BOOKED_ZERO,
    ANOMALY_ASSIGNED_LOOP,
    ANOMALY_DUPLICATE,
    ANOMALY_BOOKED_AVAILABLE,
    ANOMALY_SCHOOL_MISMATCH,
    ANOMALY_ORDERS_MISSING,
    ANOMALY_ORPHAN_TEACHERS,
    ANOMALY_VQTY_MISMATCH,

    SUPPORT,
    SUPPORT_LIST,
    SUPPORT_SHOW,

};

export { routeNames };
